/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CategoryEnum {
    Return = 'RETURN',
    FinancialResult = 'FINANCIAL_RESULT',
    Warning = 'WARNING',
    Invested = 'INVESTED',
    Documents = 'DOCUMENTS',
    Collateral = 'COLLATERAL',
    BasicData = 'BASIC_DATA',
    NewIssue = 'NEW_ISSUE',
    IssueParameters = 'ISSUE_PARAMETERS',
    News = 'NEWS'
}


export function CategoryEnumFromJSON(json: any): CategoryEnum {
    return CategoryEnumFromJSONTyped(json, false);
}

export function CategoryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryEnum {
    return json as CategoryEnum;
}

export function CategoryEnumToJSON(value?: CategoryEnum | null): any {
    return value as any;
}

